import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import LocaleText from './LocaleText';

import Button from './Button';

class NotFound extends React.Component {
    render() {
        const { lang } = this.props.match.params;

        return (
            <div className="not-found">
                <div className="not-found__inner">
                    <Isvg src="/svg/error.svg" className="not-found__image" />
                    <h1>
                        <LocaleText textKey="404.error.title" />
                    </h1>
                    <p>
                        <LocaleText textKey="404.error.copy" />
                    </p>
                    <Button to={`/${lang}`} className="is-big is-margin">
                        <LocaleText textKey="404.error.cta" />
                    </Button>
                </div>
            </div>
        );
    }
}

NotFound.propTypes = {
    match: PropTypes.object.isRequired,
};

export default NotFound;
